import React from 'react'
import Button from '../Button/Button'
import bgImage from '../../../assets/images/ui/cover.jpg'

const Cover = (props) => {
  const { startApp } = props;
  return (
    <div className="app-cover" style={{ backgroundImage: "url(" + bgImage + ")"}}>
      <div className="app-start-cta">
        <Button action={() => startApp()}>CONFIGURATOR</Button>
      </div>
    </div>
  )
}

export default Cover